
    import { Component, Vue, Prop, Watch } from 'vue-facing-decorator';

    @Component
    export default class ScenarioProcessingLog extends Vue {

        private modalShow = false;

        @Prop({ default: null }) public scenarioProcessingLog: any;
        @Prop({ default: null }) public scenario: any;
        @Prop({ default: null }) public model: any;
        @Prop({ default: null }) public user: any;
       
        @Watch('scenarioProcessingLog')
        private onModelParametersChanged(value: any) {
            if (value) {
                this.modalShow = true;
            }
            else {
                this.modalShow = false;
            }
        }

        get headers(): any {
            const h = [
                {
                    title: this.$t("message.scenario"),
                    align: 'start',
                    sortable: false,
                    key: 'scenarioName',
                },
                {
                    title: this.$t("message.scheduledDateTimeUtc"),
                    align: 'start',
                    sortable: false,
                    key: 'scheduledDateTimeUtc',
                },
                {
                    title: this.$t("message.startedDateTimeUtc"),
                    align: 'start',
                    sortable: false,
                    key: 'startedDateTimeUtc',
                },
                {
                    title: this.$t("message.isoLinesMissingDateTimeUtc"),
                    align: 'start',
                    sortable: false,
                    key: 'isoLinesMissingDateTimeUtc',
                },
                
                {
                    title: this.$t("message.endedDateTimeUtc"),
                    align: 'start',
                    sortable: false,
                    key: 'endedDateTimeUtc',
                },
                {
                    title: this.$t("message.user"),
                    align: 'start',
                    sortable: false,
                    key: 'userName',
                }
                
            ];
            if (this.model && this.model.roles && this.model.roles.includes('Owner')) {
                h.push({
                    title: this.$t("message.error"),
                    align: 'start',
                    sortable: false,
                    key: 'error',
                }
                )
            }
            return h;
        }

        private close() {
            this.modalShow = false;
        }
    }
